import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "4px 20px 4px 12px",
    color: theme.palette.text.primary,
    fontSize: 12,
    "&:nth-child(odd)": {
      backgroundColor: "#f6f6f6"
    }
  },
  horseName: {
    textTransform: "uppercase",
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
  },
  expirationInfo: {
    width: 170,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: theme.palette.text.secondary
  },
  expirationLabel: {
    marginRight: 4
  }
}));
